<template>
  <div class="rounded-md border border-gray-300 bg-white p-2 shadow-md">
    <slot />
  </div>
</template>
